import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setSuccessMessage, setErrorMessage } from "../slices/messageSlice";
import MessageBox from "./MessageBox";
import {
  ExcuteListPostCode,
  UpdatePostCode,
} from "../services/PostCodeService";
import { useNavigate } from "react-router-dom";
const PostCodesTable = ({ postCode, reload }) => {
  const dispatch = useDispatch();
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { id, createdAt, isCurrentUsed, listConfigDetail, listConfigFail } =
    postCode;
  const startDate = listConfigDetail[0]?.ngay; // First date
  const endDate = listConfigDetail[listConfigDetail.length - 1]?.ngay; // Last date
  const navigate = useNavigate();
  const handleToggle = async () => {
    const newStatus = isCurrentUsed === 1 ? 0 : 1;
    const response = await UpdatePostCode(
      id,
      postCode.listConfig,
      postCode.active,
      newStatus
    );
    if (response && response.status_code !== 200) {
      dispatch(setErrorMessage(response.message));
    } else {
      dispatch(
        setSuccessMessage(`Chuyển đổi trạng thái tự động duyệt thành công`)
      );
      reload();
    }
  };
  const handleApprove = async (id) => {
    const response = await ExcuteListPostCode(id, 1); // Approve the post code
    if (response && response.status_code !== 200) {
      dispatch(setErrorMessage(response.message));
    } else {
      dispatch(setSuccessMessage(`Duyệt Thủ Công bộ mã thành công`));
    }
  };
  const handleDeleteConfirmation = (id) => {
    setDeleteId(id);
    setShowMessageBox(true); // Show the confirmation message box
  };
  const handleDelete = async () => {
    const response = await UpdatePostCode(
      id,
      postCode.listConfig,
      0,
      isCurrentUsed
    ); // Call the delete API
    if (response && response.status_code !== 200) {
      dispatch(setErrorMessage(response.message));
    } else {
      dispatch(setSuccessMessage(`Đã Xóa bộ mã thành công`));
      navigate("/post-code-manage");
    }
    setShowMessageBox(false); // Close the message box
  };

  return (
    <div className="overflow-x-auto mb-6 p-4 border border-gray-300 dark:border-gray-600 rounded-lg">
      <div className="px-8">
        <div className="flex justify-around items-center">
          <p>
            <strong>Ngày tạo:</strong>{" "}
            {new Date(createdAt).toLocaleDateString()}
          </p>
          <p className="flex items-center">
            <label className="inline-flex items-center space-x-2">
              <strong>Trạng thái:</strong>
              <span className="relative">
                <input
                  type="checkbox"
                  checked={isCurrentUsed}
                  onChange={handleToggle}
                  className="hidden"
                />
                <span
                  className={`block w-10 h-6 rounded-full ${
                    isCurrentUsed ? "bg-blue-600" : "bg-gray-400"
                  } transition`}
                ></span>
                <span
                  className={`dot absolute left-0 top-0 w-6 h-6 rounded-full bg-white transition-transform ${
                    isCurrentUsed ? "transform translate-x-full" : ""
                  }`}
                ></span>
              </span>
              <span className="pl-2">
                {isCurrentUsed ? "Đang tự động duyệt" : "Không sử dụng"}
              </span>
            </label>
          </p>
        </div>
        <div className="flex justify-around items-center">
          <p>
            <strong>Ngày bắt đầu:</strong> {startDate}
          </p>
          <p>
            <strong>Ngày kết thúc:</strong> {endDate}
          </p>
        </div>
      </div>
      <h3 className="text-lg font-semibold my-4">Danh sách mã chi tiết</h3>
      <table className="min-w-full bg-white border border-gray-300 dark:bg-gray-800 dark:border-gray-600 mb-4">
        <thead>
          <tr className="bg-gray-200 dark:bg-gray-700">
            <th className="py-2 px-4 border">Ngày</th>
            <th className="py-2 px-4 border">Mã</th>
          </tr>
        </thead>
        <tbody>
          {listConfigDetail.map((detail, index) => (
            <tr
              key={index}
              className="hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <td className="py-2 px-4 border">{detail.ngay}</td>
              <td className="py-2 px-4 border">{detail.mabd}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3 className="text-lg font-semibold my-4">Danh sách mã thất bại</h3>
      <table className="min-w-full bg-white border border-gray-300 dark:bg-gray-800 dark:border-gray-600">
        <thead>
          <tr className="bg-gray-200 dark:bg-gray-700">
            <th className="py-2 px-4 border">Mã thất bại</th>
          </tr>
        </thead>
        <tbody>
          {listConfigFail.length > 0 ? (
            listConfigFail.map((fail, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                <td className="py-2 px-4 border">{fail}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="py-2 px-4 border text-center">
                Không có mã thất bại
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="flex justify-end space-x-4 mt-4">
        <button
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-500"
          onClick={() => handleApprove(id)}
        >
          Duyệt thủ công
        </button>
        <button
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-500"
          onClick={() => handleDeleteConfirmation(id)}
        >
          Xóa Bộ Mã
        </button>
      </div>
      {showMessageBox && (
        <MessageBox
          message={`Bạn có chắc chắn muốn xóa mã bài đăng ID: ${deleteId}?`}
          onClose={() => setShowMessageBox(false)}
          onConfirm={handleDelete}
          type="warning"
        />
      )}
    </div>
  );
};
export default PostCodesTable;
